import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReceiptList from "./index";
import LocationList from "../Components/Location";
import API from "../Services/Location";
import APIS from "../Services/Auth"

const ReceiptSetting = () => {
  const [errors, setErrors] = useState({});
  const [location, setLocation] = useState({});
  const [locationId, setLocationId] = useState("");
  const [footerNote, setFooterNote] = useState("");
  const [email, setEmail] = useState("");
  const [showData, setShowData] = useState(false);
  const [companyName, setCompanyName] = useState("")
  const [logo, setLogo] = useState("")
  const [mobile, setMobile] = useState("")
  const [gst, setGst] = useState("")

  const [visibleFields, setVisibleFields] = useState({
    email: true,
    address: true,
    website: true,
  });

  const [removedFields, setRemovedFields] = useState([]);

  const handleCancel = () => {
    window.location.reload();
  };

  const handleSave = () => {
    if (!locationId.trim()) {
      setErrors({ locationId: "Please select a center" });
      return;
    }

    toast.success("Settings saved successfully!");
    // Here you could send the modified data back to your API
  };

  const handleLocationChange = async (selectedLocationId) => {
    setLocationId(selectedLocationId);
    setErrors({});

    try {
      const payload = {
        id: selectedLocationId,
      };

      const response = await API.getLocationList(payload);
      const data = response?.data?.data?.[0] || {};
      console.log('data', data)
      setLocation(data);
      setEmail(data?.email || "");
      //setMobile(data)
      // setGst(data)
      setFooterNote(response?.data?.footerNote || "");
      setShowData(true);

      // Reset visible and removed fields when location changes
      setVisibleFields({
        email: true,
        address: true,
        website: true,
        mobile: true,
        gst: true,
      });
      setRemovedFields([]);
    } catch (error) {
      console.error("Error fetching location data:", error);
      toast.error("Failed to fetch location details.");
    }
  };

  const removeField = (field, value) => {
    setVisibleFields((prev) => ({ ...prev, [field]: false }));
    setRemovedFields((prev) => [...prev, { field, value }]);
  };

  const addFieldBack = (field) => {
    setVisibleFields((prev) => ({ ...prev, [field]: true }));
    setRemovedFields((prev) => prev.filter((item) => item.field !== field));
  };


  useEffect(() => {
    getCompniesData()
  }, [])






  const getCompniesData = async () => {
    try {
      const payload = {
        is_active: 1
      };
      const response = await APIS.getCompnies(payload);
      const fetchResponse = response?.data?.data?.rows || [];
      // console.log("fetchResponse........", fetchResponse);
      if (fetchResponse.length > 0) {
        setCompanyName(fetchResponse[0]?.name);
        setLogo(fetchResponse[0]?.logo);
      } else {
        console.warn("No companies found.");
      }

    } catch (error) {
      console.error("Failed to fetch companies:", error);
    }
  };

  return (
    <div>
      <div>


        <div className="card shadow-sm mb-1">
          <div className="card-body">
            <h4 className="card-title">Receipt Setting</h4>

            <div className="row">
              {/* Header Section */}
              <div className="col-md-6">
                <div className="card">
                  <div className="card-header bg-primary text-white">
                    <strong>Header</strong>
                  </div>
                  <div className="card-body">
                    <label className="form-label">Company Name</label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      value={companyName}

                    />

                    <label className="form-label mt-3">Logo</label>
                    <div className="border rounded p-2 text-center mb-3">
                      <img
                        src={logo ||'No Image Available'}
                        alt="Company Logo"
                        className="img-fluid"
                        style={{ maxHeight: "80px" }}
                      />
                    </div>

                    <LocationList
                      selectedLocation={locationId}
                      setSelectedLocation={handleLocationChange}
                    />
                    {errors.locationId && (
                      <small className="text-danger">{errors.locationId}</small>
                    )}

                    {showData && (
                      <section>
                        {visibleFields.mobile && (
                          <div className="mt-3">
                            <b>Mobile</b>
                            <div className="input-group mt-1">

                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Mobile"
                                value={location.phone_no}
                                onChange={(e) => setMobile(e.target.value)}
                                disabled
                              />
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => removeField("mobile", location.phone_no)}
                              >
                                <i className="mdi mdi-delete" ></i>
                              </button>
                            </div>
                          </div>
                        )}
                        {visibleFields.email && (
                          <div className="mt-1">

                            <b>Email</b>
                            <div className="input-group">

                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled
                              />
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => removeField("email", email)}
                              >
                                <i className="mdi mdi-delete" ></i>
                              </button>
                            </div>
                          </div>

                        )}

                        {visibleFields.address && (
                          <div className="mt-1">
                            <b>Address</b>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={location.address || ""}
                                disabled
                                onChange={(e) =>
                                  setLocation((prev) => ({
                                    ...prev,
                                    address: e.target.value,
                                  }))
                                }

                              />
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() =>
                                  removeField("address", location.address)
                                }
                              >
                                <i className="mdi mdi-delete" ></i>

                              </button>
                            </div>
                          </div>

                        )}
                        {visibleFields.gst && (

                          <div className="mt-1">
                            <b>GST No</b>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="GST No"
                                value={location.gst_no}
                                onChange={(e) => setGst(e.target.value)}
                                disabled
                              />
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => removeField("gst", location.gst_no)}
                              >
                                <i className="mdi mdi-delete" ></i>
                              </button>
                            </div>

                          </div>


                        )}

                        {visibleFields.website && (
                          <div className="mt-1">
                            <b>Website</b>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Website"
                                dis
                                value={location.website || ""}
                                onChange={(e) =>
                                  setLocation((prev) => ({
                                    ...prev,
                                    website: e.target.value,
                                  }))
                                }
                              />
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => removeField("website", location.website)}
                              >
                                <i className="mdi mdi-delete" ></i>
                                {/* Remove */}
                              </button>
                            </div>
                          </div>
                        )}

                        {removedFields.length > 0 && (
                          <div className="mt-4">
                            <h6>Removed Fields</h6>
                            <table className="table table-bordered table-sm">
                              <thead>
                                <tr>
                                  <th>Field</th>
                                  <th>Value</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {removedFields.map(({ field, value }) => (
                                  <tr key={field}>
                                    <td className="text-capitalize">{field}</td>
                                    <td>{value}</td>
                                    <td>
                                      <button
                                        className="btn btn-sm btn-outline-success"
                                        onClick={() => addFieldBack(field)}
                                      >
                                        Add Back
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </section>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-4">
                <div className="card h-100">
                  <div className="card-header bg-primary text-white">
                    <strong>Footer</strong>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <label className="form-label">Footer Note</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Enter footer text, address, or contact info..."
                        value={footerNote}
                        onChange={(e) => setFooterNote(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-end mt-3">
              <button className="btn btn-success me-2" onClick={handleSave}>
                Save
              </button>
              <button className="btn btn-outline-danger" onClick={handleCancel}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <ReceiptList />
      <ToastContainer />
    </div>
  );
};

export default ReceiptSetting;
